module.exports = __webpack_public_path__ + "static/img/2.71159a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20251009/2.jpg
// module id = JDOV
// module chunks = 7